<div class="page" id="page_track">
    <div class="container">

        <h2 class="section-title">O TREINO</h2>
        <p>Escolha a experiência que mais combina com você</p>

        <div class="section-divider"></div>

        <div class="window">
            <div class="tabs jiu">
                <div class="list">
                    <h4>ESTRUTURA</h4>
                    <ul> 
                        <li>
                            <b>Personal Fight</b>
                            Para quem busca um treino 100% personalizado, com foco total nos seus objetivos e acompanhamento individual do professor.
                        </li>
                        <li>
                            <b>Aulas Exclusivas até 8 pessoas</b>
                            Para quem gosta da energia de treinar em grupo, mas não abre mão de atenção individual. 
                        </li>
                    </ul>
                    <h4>METODOLOGIA</h4>
                    <ul> 
                        <li>
                            Nossa metodologia combina tecnicas das artes marciais com preparação física, criando aulas completas que desenvolvem condicionamento, força, coordenação, mobilidade e resistência de forma natural e envolvente.
                        </li>
                    </ul>
                </div>
            </div>
        </div>

        <div class="section-divider"></div>

        <div class="page-footer">
            <h4>AGENDE UMA AULA EXPERIMENTAL</h4>
            
            <a class="btn primary-line" 
                target="_blank"  
                href="https://api.whatsapp.com/send?phone=+5511976626886&text=Olá, gostaria de obter informações sobre a New Fit Performance Club"
                (click)="navigate('regclick')">
                <span>AGENDAMENTOS </span>
                <fa-icon [icon]="faWhatsapp" />
            </a>
        </div>

        <div class="section-divider"></div>


    </div>
</div>